import api from "./api";

const asignacionesCapacitador = {
  listarPuntosServicio() {
    return api.get(`/asignaciones/puntos_servicio`);
  },
  asignacionesPorPunto(psId: number | string) {
    return api.get(`/asignaciones/puntos_servicio/${psId}/asignaciones`);
  },
  asignacionesPorPersona(legajo: string | number) {
    const search = new URLSearchParams();
    search.append('legajo', String(legajo));
    return api.get(`/asignaciones/persona?${search.toString()}`);
  },
};

export default asignacionesCapacitador;
